// Central place for the brand logo — swap the URL here and it updates across the app.
export const KORPORATE_LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_link-convert-pro/artifacts/nrnust20_ChatGPT%20Image%20Aug%209%2C%202026%2C%2005_01_21%20AM.png";

/**
 * BrandLogo — renders the Korporate Links logo (crown + globe + handshake + "KORPORATE Links" wordmark).
 * The wordmark is baked into the image, so callers should NOT put a "KORPORATE" text label beside it.
 *
 * @param {number} height   — image height in px (defaults 40). Width auto-scales via `w-auto`.
 * @param {string} className — extra classes for the <img> element
 */
export default function BrandLogo({ height = 40, className = "", ...rest }) {
  return (
    <img
      src={KORPORATE_LOGO_URL}
      alt="Korporate Links"
      style={{ height, width: "auto" }}
      className={`inline-block object-contain select-none ${className}`}
      draggable={false}
      data-testid="brand-logo"
      {...rest}
    />
  );
}
